import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { networkSelectors } from '@lifesize/nucleus';
import NotificationLostConnection from 'components/NotificationLostConnection/NotificationLostConnection';
import { isDroppedCall } from '../../utils/call-utils';
import { isReconnecting as isReconnectingSelector } from 'selectors/connection';

const mapStateToProps = (state, ownProps) => {
  const activeCall = ownProps.call;
  const isCallDropped = isDroppedCall(activeCall);
  const isCallActive = ownProps.isCallActive;
  const isOffline = networkSelectors.isOffline(state);
  return {
    isReconnecting: isReconnectingSelector(state),
    isCallDropped,
    isOffline,
    isCallActive
  };
};

const ConnectedComponent = connect(mapStateToProps, () => ({}))(NotificationLostConnection);

const FunctionalComponent = (props) => {
  const isCallActive = hooks.useCallConnected();
  const call = hooks.useCallState();

  return (
    <ConnectedComponent
      {...props}
      call={call}
      isCallActive={isCallActive}
    />
  );
}

export default FunctionalComponent;
